import React from 'react';
import errorMessages from '../../../../const/errorMessages';
import errorCodes from '../../../../const/errorCodes';
import ValidationForm from '../../../forms/ValidationForm';
import PopupButtons from '../../../components/Popup/PopupButtons';
import { okButtonClass } from '../../../../const/popupButtonClasses';

class ChangePasswordForm extends React.Component {

    validatePassword = ({ password }) => {
        if (!password) {
            return 'Enter your password';
        }

        if (password && password.length < 8) {
            return errorMessages[errorCodes.passwordTooShort];
        }

        return null;
    }

    validateConfirmedPassword({ confirmedPassword, password, oldPassword }) {
        if (!confirmedPassword) {
            return 'Confirm your password';
        }

        if (password !== confirmedPassword) {
            return "Your passwords don't match";
        }

        if (oldPassword === password) {
            return "Old and new passwords are the same";
        }

        return null;
    }

    ok = ({ password, oldPassword }) => {
        this.props.changePassword(this.props.email, password, oldPassword).then(() => {
            this.setState({
                password: '',
                oldPassword: '',
                confirmedPassword: ''
            });
        }, () => {

        });
    }

    render() {
        return (
            <div className="change-password-form">
                <div className="form-sub-header">
                    Change Password
                </div>
                <ValidationForm
                    inputs={[
                        {
                            name: 'oldPassword',
                            label: 'Current password',
                            applyOnEnter: true,
                            autoComplete: 'off',
                            type: "password",
                        },
                        {
                            name: 'password',
                            label: 'New password',
                            applyOnEnter: true,
                            rules: [this.validatePassword],
                            type: "password",
                            autoComplete: 'off',
                        },
                        {
                            name: 'confirmedPassword',
                            label: 'Confirm new password',
                            rules: [this.validateConfirmedPassword],
                            applyOnEnter: true,
                            type: "password",
                            autoComplete: 'off',
                        }
                    ]}
                    buttons={[
                        {
                            key: 'ok',
                            label: 'Update Password',
                            action: this.ok,
                            className: `${okButtonClass} big only-btn`
                        }
                    ]} />
            </div>
        );
    }
}

export default ChangePasswordForm;